import { GRAMMAR, PLAGIARISM, EXPERT_CHECK } from '../types';
export var selectCheckCategoryQueryParams = function selectCheckCategoryQueryParams(state) {
  return {
    checkCategory: getCheckCategoryQueryValue(state.app.checkCategory)
  };
};
var getCheckCategoryQueryValue = function getCheckCategoryQueryValue(checkCategory) {
  switch (checkCategory) {
    case PLAGIARISM:
      return 'plagiarism';
    case EXPERT_CHECK:
      return 'expert-check';
    default:
    case GRAMMAR:
      return 'grammar';
  }
};